import { Box, Typography,IconButton } from "@mui/material";
import { useLocation,useNavigate } from "react-router-dom";
import TutorialSection from "./Tutorial";
import ReleaseNotes from "./ReleaseNotes";
import FAQs from "./FAQs";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const HelpSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const section = params.get("section") || "tutorial";

  const sectionMapping = {
    "feedback": "Feedback",
    "release-notes": "Release Notes",
    "faq": "FAQs",
    "tutorial": "Tutorial",
  };

  const pageTitle = sectionMapping[section];

  const renderSection = () => {
    switch (section) {
      case "release-notes":
        return <ReleaseNotes />;
      case "faq":
        return <FAQs />;
      case "tutorial":
      default:
        return <TutorialSection />;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f4faff",
        height: "calc(100vh - 144px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#1976d2",
          py: 4,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
            variant="h1"
            color="white"
            sx={{ display: "inline-flex", alignItems: "center", lineHeight: 1.5, marginLeft:"1%" }}
          >
            <IconButton
              onClick={()=>navigate("/drm")}
              sx={{
                color: "white",
                p: 0,
                mr: 1,
                lineHeight: 1,
              }}
            >
              <ArrowBackIosNewIcon
                fontSize="small"
                sx={{ verticalAlign: "middle" }}
              />
            </IconButton>
            {pageTitle}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 0,
          flex: 1,
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f4faff",
            borderRadius: 2,
            width: "100%",
            p:0,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          {renderSection()}
        </Box>
      </Box>
    </Box>
  );
};

export default HelpSection;
